module.exports = __webpack_public_path__ + "static/img/store_icon.3fd2548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_icon.png
// module id = 2x0/
// module chunks = 1